<content-filter [config]="config()" [content]="content()" [editor]="options().editor"></content-filter>
